import { render, staticRenderFns } from "./ContBoTab.vue?vue&type=template&id=3c3adbc1&scoped=true&"
import script from "./ContBoTab.vue?vue&type=script&lang=js&"
export * from "./ContBoTab.vue?vue&type=script&lang=js&"
import style0 from "./ContBoTab.vue?vue&type=style&index=0&id=3c3adbc1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3adbc1",
  null
  
)

export default component.exports